import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import {createMigrate, persistReducer, persistStore} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {configureStore, combineReducers} from "@reduxjs/toolkit";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import storePartners from "./store-partners";
import storeFilter from "./store-filter";
import storeLocalData from "./store-local";
import migrations from "./migrations";

const VERSION = 0;

/** local Storage config */
const localPersistConfig = {
	key: `$$YBLOCAL_PRDT_${publicRuntimeConfig.RUNTIME_ENV}`,
	version: VERSION,
	storage,
	whitelist: [],
	migrate: createMigrate(migrations, {debug: true}),
};

const rootReducer = combineReducers({
	partnersStore: storePartners,
	goodsFilterStore: storeFilter,
	localDataStore: storeLocalData,
});

const persistedReducer = persistReducer(localPersistConfig, rootReducer);

const store = configureStore({
	reducer: persistedReducer,
	devTools: ["development", "local"].indexOf(publicRuntimeConfig.RUNTIME_ENV) > -1,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
// Define Typed Hooks
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const persistor = persistStore(store);
export default store;
